import * as THREE from "three";
import Experience from "../Experience.js";

export default class Raycaster {
  constructor() {
    this.experience = new Experience();
    this.camera = this.experience.camera;

    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    // Store current mouse position
    this.currentMouse = { x: 0, y: 0 };

    // Bind mouse move handler
    this.boundMouseMove = this.onMouseMove.bind(this);
    this.setupEventListeners();
  }

  setupEventListeners() {
    window.addEventListener("mousemove", this.boundMouseMove);
  }

  onMouseMove(event) {
    // Update normalized mouse coordinates
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // Store raw mouse position for other uses
    this.currentMouse.x = event.clientX;
    this.currentMouse.y = event.clientY;
  }

  castRay(objects, recursive = true) {
    this.raycaster.setFromCamera(this.mouse, this.camera.instance);
    return this.raycaster.intersectObjects(objects, recursive);
  }

  isHovering(objects, recursive = true) {
    const intersects = this.castRay(objects, recursive);
    return intersects.length > 0;
  }

  getFirstIntersection(objects, recursive = true) {
    const intersects = this.castRay(objects, recursive);
    return intersects.length > 0 ? intersects[0] : null;
  }

  getMouseNDC() {
    return this.mouse.clone();
  }

  getMouseScreen() {
    return { ...this.currentMouse };
  }

  dispose() {
    window.removeEventListener("mousemove", this.boundMouseMove);
  }
}
